import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rr-start-logo',
  standalone: false,

  templateUrl: './start-logo.component.html',
  styleUrl: './start-logo.component.scss'
})
export class StartLogoComponent implements OnInit {
  @Input() color: string = '';

  constructor(private cdr: ChangeDetectorRef) { }


  ngOnInit() {
    this.cdr.detectChanges();
  }
}
